import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Modal, Spinner } from "react-bootstrap";
import { HourglassSplit } from "react-bootstrap-icons";

export const WaitingModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showTimeout = setTimeout(() => {
      setShow(true);
    }, 500);
    return () => {
      clearTimeout(showTimeout);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Modal show={true} onHide={() => {}} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex">
          <HourglassSplit className="align-self-center me-2 text-info" />
          <span>
            <FormattedMessage id="component.common.loading.loading" />
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">
              <FormattedMessage id="component.common.loading.loading" />
            </span>
          </Spinner>
        </div>
      </Modal.Body>
    </Modal>
  );
};
